import { useEffect } from 'react';
import { holdUpdate } from '@/lib/update-safety';

/**
 * Block app-update reloads (silent, forced and the Refresh button) while
 * `active` is true. One line per call site; released on change or unmount.
 */
export function useUpdateHold(active: boolean, reason: string): void {
  useEffect(() => {
    if (!active) return;
    return holdUpdate(reason);
  }, [active, reason]);
}
